const timeDate = require ('../../../../../js-handler/time-date')

const settings         = require('../../../../../js-handler/settings')
const inventoryDt      = require('./inventory-dt')
const inventorySnack   = require('./inventory-snack')
const reportInventory  = require ('./inventory-report-item-available')



export function getshelflifestyle(elem) {  
    let default_shelf_life = settings.getData().default_shelf_life;
    let alert_shelf_life = settings.getData().alert_shelf_life;
    let shelf_life = 0;
    let delivered_date = new Date(elem.remaining_days); // Convertir la fecha de entrega a objeto de fecha
    let today = new Date(); // Obtener la fecha actual
    let days_elapsed = Math.floor((today - delivered_date) / (1000 * 60 * 60 * 24)); // Calcular los días transcurridos
    let days_remaining = 0;
    let alert = "";
    let icon = "";
    let descr = "";

    if(elem.shelf_life === 0 ){
        shelf_life = default_shelf_life;
    }else{
        shelf_life = elem.shelf_life;
    }

   
    days_remaining = parseInt(shelf_life) - parseInt(days_elapsed);
    
    
    if (days_remaining == 0) {
        alert = "Expired";
        icon = { color: 'td-red-icon', svg: 'check-round' };
        descr = "Today";
    } 
    else if (days_remaining <= 0) {
        alert = "Expired";
        icon = { color: 'td-red-icon', svg: 'check-round' };
        descr = Math.abs(days_remaining) + " days ago";
    }
    else if (days_remaining <= alert_shelf_life) {
        alert = "Expiring soon";
        icon = { color: 'td-orange-icon', svg: 'check-round' };
        descr = "On " + days_remaining + " days";
    } else if( Number.isNaN(days_remaining)) {
        alert = shelf_life + " days "
        icon = { color: 'td-gray-icon', svg: 'check-round' };
        descr = "Not Delivered Yet";
        //console.log(elem.remaining_days)
    }
    else {
        alert = "Expires On";
        icon = { color: 'td-gray-icon', svg: 'check-round' };
        descr = "On " + days_remaining + " days";
        //console.log(elem.remaining_days)
    }

    return { alert: alert, icon: icon, descr: descr };   
}



// funcion para actualizar el selling price del item seleccionado en los purchase que este incluido y que tengan inventario
export function updateSellingPrice(detail) {

    let dbid            = detail.dbid;
    let newSellingPrice = detail.newSellingPrice;
    let item_unit_id    = detail.item_unit_id;

    if (dbid == undefined || dbid == "" || dbid == null) {
        return;
    }
    if (newSellingPrice == undefined || newSellingPrice == "" || newSellingPrice == null) {
        return;
    }

    const formData = new FormData();
    formData.append('item_id', dbid);
    formData.append('item_unit_id', item_unit_id);
    formData.append('newSellingPrice', newSellingPrice);

    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort() }, 30000);

    let options = {
        method: 'POST',
        body: formData,
        signal: controller.signal,
        credentials: 'same-origin'
    };

    fetch(`./server/php/sql/updatePurchaseItemSellingPrice.php`, options)
        .then(result => result.json())
        .then(result => {
            if (result.error.val =="error") {
                inventorySnack.start({ act: 'show', id: 'ErrorUpdate' });
            }else{
                inventorySnack.start({ act: 'show', id: 'SuccessUpdate' });
                let reportPage = document.getElementById('report-page-right');
                if (reportPage != null && reportPage != undefined && !reportPage.classList.contains('dn')) {
                    reportInventory.start({"dest":"inventory", "elem":"report", "reportType":"reportItemAvailable", "entity":"inventory"})
                }else{
                    inventoryDt.start({"dest":"inventory", "elem":"dt", "act":"select", "entity":"inventory"})
                }
                //  {"dest":"inventory", "elem":"report", "reportType":"reportItemAvailable", "entity":"inventory"} 
            }
        })
        .catch(error => {
            inventorySnack.start({ act: 'show', id: 'ErrorUpdate' });
        });
}





// export function getshelflifestyle(elem){  

//     // console.log(settings.getData());
//     let default_shelf_life = settings.getData().default_shelf_life
//     let alert_shelf_life   = settings.getData().alert_shelf_life
//     let shelf_life         = 0;
//     let alert              = "";
//     let icon               = "";
//     let descr              = "";

//     // console.log("sheft life",elem.shelf_life)

//     if(elem.shelf_life === 0 ){
//         shelf_life = default_shelf_life;
//     }else{
//         shelf_life = elem.shelf_life;
//     }

//     console.log("sheft life setting",(parseInt(shelf_life) - parseInt(elem.remaining_days)))

//     if (shelf_life < elem.remaining_days) {
//         alert="Expired";
//         icon = {color:'td-red-icon', svg:'check-round'};
//         descr= "Expired " + (parseInt(elem.remaining_days) - parseInt(shelf_life)) +   " day ago"
//         console.log('expired', descr)


//     }else if ( parseInt(shelf_life) - parseInt(elem.remaining_days)  <= alert_shelf_life ) {
//         alert="Expiring soon";
//         icon = {color:'td-orange-icon', svg:'check-round'};
//         descr= "On " + ( parseInt(shelf_life) -  parseInt(elem.remaining_days) ) + " days"
//         // console.log('expired soon', descr)
        
//     }else{
//         alert="Expiring soon";
//         icon = {color:'td-gray-icon', svg:'check-round'};
//         descr= "On " + ( parseInt(shelf_life) -  parseInt(elem.remaining_days) ) + " days"

//     }


//     return {alert: alert, icon:icon, descr:descr };   
    
 
//  }